import { render, staticRenderFns } from "./EmptyInbox.vue?vue&type=template&id=405c7a9c&"
import script from "./EmptyInbox.vue?vue&type=script&lang=js&"
export * from "./EmptyInbox.vue?vue&type=script&lang=js&"
import style0 from "./EmptyInbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports